import { render, staticRenderFns } from "./CompanyAdminInformation.vue?vue&type=template&id=130d5a3c&"
import script from "./CompanyAdminInformation.vue?vue&type=script&lang=js&"
export * from "./CompanyAdminInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports